<ng-container *ngIf="!disableContentPage; else contentWithoutWrapper">
  <gatewee-content-page
    [breadcrumb]="
      breadcrumb.length
        ? breadcrumb
        : [
            {label: titlePath | translate, path: '/settings'},
            {label: title | translate}
          ]
    "
    [title]="title | translate"
  >
    <div page-body>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </gatewee-content-page>
</ng-container>

<ng-template #contentWithoutWrapper>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</ng-template>

<ng-template #contentTemplate>
  <div class="gw-flex gw-justify-end gw-mb-6">
    <gatewee-button
      [title]="'features.users.invite' | translate"
      variant="primary"
      iconName="@phi.user-plus"
      (click)="openInviteModal()"
    ></gatewee-button>
  </div>

  <div
    class="gw-rounded-xl gw-shadow-sm gw-border gw-border-border-normal gw-overflow-hidden"
  >
    <gatewee-table-v2
      *ngIf="users && columns.length"
      [data]="users"
      [columns]="columns"
      [page]="page"
      [pageSize]="pageSize"
      [total]="total || users.length"
      [showSettings]="true"
      [tableId]="'users-table'"
      (outClick)="onActionClicked($event)"
      (newPage)="onPageChange($event)"
    ></gatewee-table-v2>
  </div>
</ng-template>

<!-- Invite User Modal -->
<ng-template #inviteUserModal let-close>
  <div
    class="gw-flex gw-items-center gw-justify-between gw-border-b gw-border-border-normal"
  >
    <h4
      class="gw-text-xl gw-font-semibold gw-text-text-primary"
      id="modal-invite-title"
    >
      {{ 'features.users.inviteModal.title' | translate }}
    </h4>
  </div>
  <div>
    <form [formGroup]="inviteForm">
      <div class="gw-mb-6">
        <gatewee-input-v2
          [form]="inviteForm"
          controlName="email"
          label="features.users.inviteModal.email"
          id="invite-email"
          type="email"
          [required]="true"
          [placeholder]="
            'features.users.inviteModal.emailPlaceholder' | translate
          "
        ></gatewee-input-v2>
      </div>
      <div class="gw-mb-6">
        <gatewee-select-v3
          formControlName="role"
          [label]="'features.users.inviteModal.role' | translate"
          [items]="roles"
          [required]="true"
          [placeholder]="
            'features.users.inviteModal.rolePlaceholder' | translate
          "
        ></gatewee-select-v3>
      </div>
      <div class="gw-flex gw-justify-end gw-gap-3">
        <gatewee-button
          [title]="'common.actions.cancel' | translate"
          variant="secondary"
          (click)="closeInviteModal(close)"
          [disabled]="loading"
        ></gatewee-button>
        <gatewee-button
          [title]="'features.users.inviteModal.submit' | translate"
          variant="primary"
          (click)="handleInvite(close)"
          [disabled]="inviteForm.invalid || loading"
        ></gatewee-button>
      </div>
    </form>
  </div>
</ng-template>

<!-- User View Modal -->
<ng-template #userViewModal let-close>
  <div
    class="gw-flex gw-items-center gw-justify-between gw-border-b gw-border-border-normal"
  >
    <h4
      class="gw-text-xl gw-font-semibold gw-text-text-primary"
      id="modal-user-view-title"
    >
      {{ 'features.users.view.title' | translate }}
    </h4>
  </div>
  <div *ngIf="selectedUser">
    <!-- User Details -->
    <div class="gw-space-y-6">
      <div class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 gw-gap-4">
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.users.view.name' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ selectedUser.name }}
          </p>
        </div>
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.users.view.email' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ selectedUser.email }}
          </p>
        </div>
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.users.view.role' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ selectedUser.role | uppercase }}
          </p>
        </div>
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.users.view.status' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            <span [tuiStatus]="getStatusClass(selectedUser.status)">
              {{ getStatusLabel(selectedUser.status) | translate }}
            </span>
          </p>
        </div>
        <div *ngIf="selectedUser.phone">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.users.view.phone' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ selectedUser.phone }}
          </p>
        </div>
        <div *ngIf="selectedUser.createdAt">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.users.view.createdAt' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ selectedUser.createdAt | date : 'dd/MM/yyyy HH:mm:ss' }}
          </p>
        </div>
      </div>

      <!-- Actions -->
      <div class="gw-border-t gw-border-border-normal gw-pt-6">
        <h5 class="gw-text-lg gw-font-semibold gw-text-text-primary gw-mb-4">
          {{ 'features.users.view.actions.title' | translate }}
        </h5>
        <div class="gw-flex gw-flex-wrap gw-gap-3">
          <gatewee-button
            *ngIf="isPending(selectedUser) && actions.onResendInvitation"
            [title]="'features.users.view.actions.resendInvitation' | translate"
            variant="secondary"
            (click)="handleResendInvitation(selectedUser)"
            [disabled]="loading"
            icon="@tui.redo"
          ></gatewee-button>
          <gatewee-button
            *ngIf="isActive(selectedUser) && actions.onSuspendAccess"
            [title]="'features.users.view.actions.suspendAccess' | translate"
            variant="secondary"
            (click)="handleSuspendAccess(selectedUser)"
            [disabled]="loading"
            icon="@tui.ban"
          ></gatewee-button>
          <gatewee-button
            *ngIf="isSuspended(selectedUser) && actions.onActivateAccess"
            [title]="'features.users.view.actions.activateAccess' | translate"
            variant="secondary"
            (click)="handleActivateAccess(selectedUser)"
            [disabled]="loading"
            icon="@tui.check-circle"
          ></gatewee-button>
          <gatewee-button
            *ngIf="actions.onEdit"
            [title]="'features.users.view.actions.edit' | translate"
            variant="primary"
            (click)="actions.onEdit!(selectedUser); close()"
            icon="@tui.edit"
          ></gatewee-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
